module.exports = __webpack_public_path__ + "img/19c-doc-publicacoes-acoes.95ad0d73.png";